module.exports = __webpack_public_path__ + "static/media/go-read-full-tm-reversed.af422ada.svg";